import { render, staticRenderFns } from "./DataPresentation.vue?vue&type=template&id=1e0670aa&scoped=true&"
import script from "./DataPresentation.vue?vue&type=script&lang=js&"
export * from "./DataPresentation.vue?vue&type=script&lang=js&"
import style0 from "./DataPresentation.vue?vue&type=style&index=0&id=1e0670aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0670aa",
  null
  
)

export default component.exports